import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card } from 'antd';
import api from '../../api';
import helpers from '../../helpers'
import CustomDataTable from '../../components/custom-data-table/custom-data-table';
import FaIcon from '../../components/global/fa-icon/fa-icon';


let _movieHelper = helpers.movie;


let _dateFormatter = (dateStr) => {
  return _movieHelper.formatLongDateValue(dateStr);
};

/* let _sortIndexFormatter = (sortIndex, row, rowIdx) => {
  return (row && row.publishedBooleanValue)? _.parseInt(sortIndex): null;
}; //*/

let _messageFormatter = (str) => {
  let lines = _.split(str, /[\r\n]/);
  return (
    <React.Fragment>
      {_.map(lines, (line, lineIdx) => (<div key={lineIdx}>{line}</div>))}
    </React.Fragment>
  );
};

let _publishedArchivedFormatter = (archived) => {
  return archived? (
    <div className="archived d-flex flex-column justify-content-center">
      <FaIcon className="archived-icon center" icon="fa-2x fa-archive" />
    </div>
  ): (
    <div className="published d-flex flex-column justify-content-center">
      <FaIcon className="published-icon center" icon="fa-2x fa-check" />
    </div>
  );
};

let _columnHeaders = [
  {
    label: 'Sort Order',
    field: 'sortIndexIntValue',
    // formatter: _sortIndexFormatter,
    sort: 'asc',
    width: 50
  },
  {
    label: 'Message',
    field: 'message',
    formatter: _messageFormatter,
    sort: 'asc',
    width: 500
  },
  {
    label: 'Published',
    field: 'archivedMomentValue',
    formatter: _publishedArchivedFormatter,
    sort: 'asc',
    width: 350
  },
  {
    label: 'Created',
    field: 'created',
    formatter: _dateFormatter,
    sort: 'desc',
    width: 250
  },
  {
    label: 'Modified',
    field: 'modified',
    formatter: _dateFormatter,
    sort: 'desc',
    width: 250
  },
];

let _pageNumOffset = 1;

let _paginationOpts = {
  l: 40,
};

class NewsListView extends Component {

  constructor(props) {
    super(props);

    this.movieHelper = _movieHelper;

    let pageData = CustomDataTable.EmptyPageData;
    pageData.maxItemsPerPage = _paginationOpts.l;
    pageData.activePageIdx = 0;
    pageData.firstPageIdx = 0;
    pageData.lastPageIdx = 0;
    // pageData.pageDisplayOffset = 0;

    let sortData = CustomDataTable.EmptySortData;

    this.state = {
      items: null,
      pageData: pageData,
      sortData: sortData,
      tableSearch: null,
      // tableSort: null,
      // tablePage: null,
    };

    this.handleAddClicked = this.handleAddClicked.bind(this);
    this.handleSearchChanged = this.handleSearchChanged.bind(this);
    this.handleSortChanged = this.handleSortChanged.bind(this);
    this.handlePageChanged = this.handlePageChanged.bind(this);
    this.handleRowClicked = this.handleRowClicked.bind(this);
    this.invalidateData = this.invalidateData.bind(this);

    this.invalidateData();
  }

  handleAddClicked() {
    this.props.history.push('/news/add');
  }

  handleSearchChanged(e) {
    // console.log('handleSearchChanged: ' + JSON.stringify(e));
    this.setState({ tableSearch: e }, this.invalidateData);
  }

  handleSortChanged(e) {
    // console.log('handleSortChanged: ' + JSON.stringify(e));

    if (!_.isEqual(this.state.sortData, e)) {
      let sortData = _.cloneDeep(this.state.sortData);

      // TODO: joe- handle this case

      this.setState({ sortData }, this.invalidateData);
    }
  }

  handlePageChanged(e) {
    // console.log('handlePageChanged: ' + JSON.stringify(e));

    if (this.state.pageData.activePageIdx !== e.activePageIdx) {
      let pageData = _.cloneDeep(this.state.pageData);
      pageData.activePageIdx = e.activePageIdx;

      this.setState({ pageData }, this.invalidateData);
    }
  }

  handleRowClicked(dataItem) {
    // navigate to edit page
    let id = _.get(dataItem, 'id', null);
    this.props.history.push('/news/edit/' + id);
  }

  invalidateData() {
    let q = {};
    q = _.extend(q, _paginationOpts);

    q.p = (this.state.pageData.activePageIdx || 0) + _pageNumOffset;

    if (this.state.tableSearch && !_.isEmpty(this.state.tableSearch)) {
      q.f = 'message|' + this.state.tableSearch;
      q.p = _pageNumOffset;    // revert to first page when searching
    }

    // console.log('invalidateData: tableSort: ' + JSON.stringify(this.state.tableSort));

    // sort field and sort order
    if (this.state.tableSort) {
      q.sf = _.replace(this.state.tableSort.column, /_?Formatted$/i, '');
      q.so = this.state.tableSort.direction || 'asc';
    } else {
      q.sf = 'archived,sort_index,created';
      q.so = 'asc,asc,desc';
    }

    if (this.prevQuery && _.isEqual(this.prevQuery, q)) {
      return false;
    }
    this.prevQuery = q;

    return api.news.find(q).then(res => {
      let items = _.get(res, 'data') || null;
      items = _.chain(items)
        .map(item => {
          if (!item) { return null; }
          return item;
        })
        .compact()
        .value();

      let pageData = _.cloneDeep(this.state.pageData);

      let meta = _.get(res, 'meta') || null;
      if (meta) {
        pageData.activePageIdx = meta.pageNumber - _pageNumOffset;
        pageData.numItems = meta.totalRecords;
        pageData.numTotalPages = meta.totalPages;
        pageData.numTotalItems = meta.totalRecords;
        pageData.lastPageIdx = pageData.numTotalPages - 1;
     }

      this.setState({ items, pageData });
      return true;
    });
  }

  render() {

    let rows = this.state.items;
    if (_.isEmpty(rows)) { rows = []; }

    let tableData = this.state.items;
    // let tableSortOrder = (this.state.tableSort)? [this.state.tableSort.column, this.state.tableSort.direction]: ['release_date', 'desc'];


    // let searchText = null;
    let sortData = this.state.sortData;
    let pageData = this.state.pageData;

    return (
      <div className="news-list-view mx-auto" >
        <Card>
          <CustomDataTable
            striped={true}
            showAddButton={true}
            showSearch={true}
            showSort={true}
            showPaging={true}

            onAddClicked={this.handleAddClicked}
            onSearchChanged={this.handleSearchChanged}
            onSortChanged={this.handleSortChanged}
            onPageChanged={this.handlePageChanged}
            onRowClicked={this.handleRowClicked}

            headers={_columnHeaders}
            data={tableData}

            title="Manage News"
            searchLabel={''}
            sortData={sortData}
            pageData={pageData}
          />
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  // setAuthState,
  // getAuthSessionStateToken,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewsListView));

